module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container com-list"
  }, [_c('com-title', {
    attrs: {
      "title": _vm.title,
      "subtitle": _vm.subtitle
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "columns"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-one-third"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.word))])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-538d786e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/training/com-list.vue
// module id = 450
// module chunks = 1